import React from 'react';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { EmptyState } from '../../../../../../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { useSpecificPositions } from './useSpecificPositions';
import { AllocationContent } from '../AllocationContent/AllocationContent';
import { AllocationTaxStatusDTO } from '../../../../../../../../api/useAccountsQuery';

interface Props {
  assetAllocationTaxStatus: AllocationTaxStatusDTO | null;
}

export const SpecificPositions = ({ assetAllocationTaxStatus }: Props) => {
  const { data } = useSpecificPositions({ assetAllocationTaxStatus });

  if (!data) {
    return (
      <Box py="24">
        <EmptyState />
      </Box>
    );
  }

  return (
    <AllocationContent
      chartValues={data.chartValues}
      assetAllocationTaxStatus={assetAllocationTaxStatus}
      readOnly
    />
  );
};
